import { render, staticRenderFns } from "./grupo_producto_crud.vue?vue&type=template&id=a2773e98"
import script from "./grupo_producto_crud.vue?vue&type=script&lang=js"
export * from "./grupo_producto_crud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports